import { FC } from 'react';
import { Theme } from '@mui/material';
import MembersTable from './MembersTable';
import SettingsHeader from './MembersHeader';
import InviteUserContainer from '../containers/InviteUserContainer';
import RemoveMemberContainer from '../containers/RemoveMemberContainer';
import RevokeInvitationContainer from '../containers/RevokeInvitationContainer';
import UpdateUserRolesContainer from '../containers/UpdateUserRolesContainer';
import {
  ActiveMember,
  PendingInvitationMember,
  Role,
} from '../types/members-types';
import { makeStyles } from 'tss-react/mui';
import ResendInvitationContainer from '../containers/ResendInvitationContainer';

const Members: FC<React.PropsWithChildren<MembersProps>> = ({
  members,
  availableRoles,
  isReadOnlyUser,
  pendingInvitationMembers,
}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.members}>
      <InviteUserContainer availableRoles={availableRoles} />
      <UpdateUserRolesContainer availableRoles={availableRoles} />
      <RemoveMemberContainer />
      <RevokeInvitationContainer />
      <ResendInvitationContainer />
      <div className={classes.section}>
        <SettingsHeader isInviteUserDisabled={isReadOnlyUser} />
      </div>
      <div className={classes.section}>
        <MembersTable
          activeMembers={members}
          pendingInvitationMembers={pendingInvitationMembers}
          isReadOnlyUser={isReadOnlyUser}
        />
      </div>
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  members: {
    alignItems: 'center',
    gap: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  section: {
    width: '100%',
  },
}));

interface MembersProps {
  members: ActiveMember[];
  availableRoles: Role[];
  isReadOnlyUser: boolean;
  pendingInvitationMembers: PendingInvitationMember[];
}

export default Members;
